import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { PublicService } from 'src/app/services/public.service';
import {
  MatSnackBar,
  MatSnackBarConfig,
} from '@angular/material/snack-bar';

@Component({
  selector: 'app-create-blog',
  templateUrl: './create-blog.component.html',
  styleUrls: ['./create-blog.component.css']
})
export class CreateBlogComponent implements OnInit {

  blogForm = new FormGroup({
    blog_url : new FormControl(''),
    blog_name: new FormControl('')
  });

  @Input()
  username;

  constructor(private pService: PublicService,private snackBar: MatSnackBar) { }

  ngOnInit(): void {
  }

  createBlog(){
    var data = {
      "username":this.username,
      "blog_url" : this.blogForm.get('blog_url').value,
      "blog_name" : this.blogForm.get('blog_name').value
    }
    if(this.blogForm.valid){
      this.pService.createBlog(data).subscribe(res=>{

          this.showSnackBar(res+" added","OK");
          window.location.reload();

      },
      err=>{
        if(err.status == 404){
          this.showSnackBar("try different url !!!","OK");

        }else{
          this.showSnackBar("something went wrong !!!","OK");

        }
      }
      )
    }
  }

  name = 'Angular 4';



  showSnackBar(msg:string,label:string) {
    let config = new MatSnackBarConfig();
    config.duration = 20000;
    this.snackBar.open(msg, label, config);
  }

}
